import { type Progress } from '@factorialco/deprecated-design-system'

import type { Promotions } from 'modules/ats/store/collections/promotions'
import type Job from 'modules/ats/store/models/Job'

import type { LinkedInCampaignForm, LinkedInContractForm, VonqCampaignForm } from './Forms'

export enum StepEvent {
  Restart,
  Next,
  Back,
  Stop,
}

export interface StepParams {
  job: Job
  promotions: Promotions
  onStepEvent: (event: StepEvent) => void
  onClose: () => void
  progress: Progress
  linkedInContractForm: LinkedInContractForm
  vonqCampaignForm: VonqCampaignForm
  linkedInCampaignForm: LinkedInCampaignForm
}
